module.exports = __webpack_public_path__ + "media/images/logo/nombre_logo-0aeccf0a5520206b392451294b9f4559.svg";